<template>
  <div class="userBg boxHeight" style="height: 92%">
    <div class="menuNva">
      <div class="logo">
        <router-link tag="a" to="/" style="display: inline">
          <!-- <img src="../../assets/img/logoWhite.png" width="130" /> -->
          <img :src="companyLogo" width="123" height="32" style="width: 123px; height: 32px; max-width: 100%; max-height: 100%; object-fit: contain" />
        </router-link>
      </div>
      <div>
        <a href="/checkList/quotes" class="xBlueBtn quotesBtn">NEW QUOTES</a>
      </div>
      <el-menu
        class="el-meun"
        :default-active="activeMenu"
        :unique-opened="unique"
      >
        <template v-for="(item, i) in menuInfo">
          <el-submenu
            :key="i * 2"
            :index="String(item.ID)"
            v-if="item.ChildMenu.length && item.IsShow"
          >
            <template slot="title">
              <i :class="item.MenuIcon" class="fa"></i>
              <span>{{ item.MenuName }}</span>
            </template>
            <template v-for="(itemSon, j) in item.ChildMenu">
              <router-link :to="itemSon.MenuUrl" :key="j" v-if="itemSon.IsShow">
                <el-menu-item :index="String(itemSon.ID)">
                  <span>{{ itemSon.MenuName }}</span>
                </el-menu-item>
              </router-link>
            </template>
          </el-submenu>
          <template v-if="!item.ChildMenu.length">
            <router-link
              :to="item.MenuUrl"
              :key="i * 2 + 1"
              v-if="item.IsShow || item.ID === 1"
            >
              <el-menu-item :index="String(item.ID)" class="topmenu">
                <i :class="item.MenuIcon" class="fa"></i>
                <span>{{ item.MenuName }}</span>
              </el-menu-item>
            </router-link>
          </template>
        </template>
      </el-menu>
    </div>
    <div class="menuRCon footerPosition" style="">
      <div class="menuTop">
        <div class="menuTopImg w200">
          <img src="/static/img/1_proc.png" />
        </div>
        <div class="menuTopImg w157">
          <img src="/static/img/2_proc.png" />
        </div>
        <div class="menuTopImg w155">
          <img src="/static/img/3_proc.png" />
        </div>

        <div class="user r location">
          <a class="userImg">
            <!-- <img
              class="l"
              src="../../assets/img/samImgPersoanl.png"
              width="30"
            /> -->

            <div class="user-img-new">
              <span>{{ userNameTwo }}</span>
            </div>
            <i class="fa fa-arrDown marL5"></i>
          </a>
          <!--鼠标放在头像上的下拉框-->
          <div class="noticeBox" style="min-width: 180px; max-width: 300px">
            <i></i>
            <ul>
              <li>
                <b>{{ userName }}</b>
              </li>
              <li>
                <b>{{ userEmail }}</b>
              </li>
              <li class="line"></li>
              <li>
                <a class="basInfo" href="/myInfo/basicInfo"
                  ><b>Basic Info.</b></a
                >
              </li>
              <li>
                <a class="basInfo" @click="clkLogout"><b>Sign Out</b></a>
              </li>
            </ul>
          </div>
        </div>
        <div class="msgIcons r location">
          <label>
            <!-- <i class="fa fa-iconMsg colGray3"></i><span class="info">{{InformationSum}}</span> -->
          </label>
          <div class="msgImg">
            <img
              src="../../../static/img/basicInfo/ic_message@2x.png"
              width="28"
              height="28"
              alt="msg"
            />
            <div class="msgNumber" v-if="InformationSum > 0"></div>
          </div>
          <!--v-if="InformationSum > 0" v-if="InformationSum"-->
          <div class="noticeBox specLi" style="width: 300px; right: -117px">
            <i style="left: 47%"></i>
            <ul>
              <li class="colRed">Messages for your orders</li>
              <li v-for="(item, index) in InformationInfo" :key="index">
                <span class="fa fa-msgIcon marR5"></span>
                <a
                  v-if="item.order_id.indexOf('WE') !== -1"
                  :href="delUrl + 'exp/expDetails?ord=' + item.order_id"
                >
                  <span class="marR5">{{ item.order_id }}</span>
                  <span>{{ subsChannelText(item.body) }}</span>
                </a>
                <a
                  v-if="item.order_id.indexOf('WA') !== -1"
                  :href="delUrl + 'air/airDetails?ord=' + item.order_id"
                >
                  <span class="marR5">{{ item.order_id }}</span>
                  <span>{{ subsChannelText(item.body) }}</span>
                </a>
              </li>
              <!-- <li class="lastLi">End of List</li> -->
            </ul>
          </div>
        </div>
      </div>
      <div
        class="menuMain"
        :style="$route.path === '/checkList/quotes' ? 'margin:0' : ''"
      >
        <!-- <keep-alive> -->
        <!-- 页面缓存 -->
        <!-- <router-view v-if="$route.meta.keepAlive"></router-view> -->
        <!-- </keep-alive> -->
        <!-- <router-view v-if="!$route.meta.keepAlive"></router-view> -->
        <router-view></router-view>
      </div>
      <footerInfo></footerInfo>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import Vue from "vue";
import bus from "../../ask/eventBus";
import { post, fetch } from "../../ask/axios";
import { setCustomer } from "@/utils/getCustomer";
import { delCookie, getCookie } from "../../ask/cookiejs";
import footerInfo from "../reception/public/footerInfo.vue";
import { pinyin } from "pinyin-pro";

export default {
  components: { footerInfo },
  data() {
    return {
      api: {
        url: "",
        param: "",
        response: {},
        message: "",
      },
      //左侧菜单
      menuInfo: [],
      firstID: [], //当前显示id  [过去，现在] || [现在]
      secondID: "", //当前显示id
      activeMenu: "", //当前活动菜单
      unique: true, //只支持一个展开菜单

      //未读消息
      InformationInfo: [
        //                {order_id:'WA180000029',body:'shows the first 10 words in the message message message message...'},
      ],
      InformationSum: 0,

      //用户信息
      userName: "",
      userNameTwo: "",
      userEmail: "",
      companyLogo: "",

      // IsWCA:false,//是否是WCA成员，是的话费用中不收取银行手续费，不是的要收取
    };
  },
  //深度监听事件
  watch: {},
  created() {
    this.getMenuInfo(); //左侧菜单接口
    this.userTopInfo(); //用户信息
    setInterval(this.UnreadInformation, 60000); //隔1分钟调用一次
  },
  mounted() {
    //dom已经生成

    // 私人定制调用接口
    bus.$on("reGetMenuInfo", (res) => {
      this.getMenuInfo();
    });
    bus.$on("updateCompanyLogo", (res) => {
      this.userTopInfo();
    });
  },
  computed: {
    //计算属性
    delUrl() {
      return this.$apiEn;
    },
  },
  methods: {
    //配置只做显示用 //匹配路由高亮 //相同id 代表是相同路由匹配这一个
    isLight() {
      // otherUrl 菜单栏没有返回的地址
      let otherUrl = [
        {
          path: ["/exp/expEdit", "/exp/expDetails", "/exp/expSucceed"],
          replaceUrl: "/exp/expList",
        },
        {
          path: ["/air/airEdit", "/air/airSucceed", "/air/airDetails"],
          replaceUrl: "/air/airList",
        },
        {
          path: [
            "/pickUp/pickUpEdit",
            "/pickUp/PickupOrderSucceed",
            "/pickUp/pickUpOrder",
            "/pickup/pickupDetails",
          ],
          replaceUrl: "/pickUp/pickUpList",
        },
      ];
      var addressUrl = this.$route.path; //获取当前页面的url ?前面的值
      // 如果是其他地址就把 当前地址当成替换的地址去找id 赋值上去
      otherUrl.forEach((ele) => {
        if (ele.path.indexOf(this.$route.path) !== -1) {
          addressUrl = ele.replaceUrl;
        }
      });
      if (this.menuInfo) {
        if (this.menuInfo.length > 0) {
          for (let i = 0; i < this.menuInfo.length; i++) {
            let ele = this.menuInfo[i];
            if (ele.MenuUrl && ele.MenuUrl == addressUrl) {
              this.activeMenu = String(ele.ID); //需要字符串属性
            }
            for (let j = 0; j < ele.ChildMenu.length; j++) {
              if (addressUrl == ele.ChildMenu[j].MenuUrl) {
                this.activeMenu = String(ele.ChildMenu[j].ID);
              }
            }
          }
        }
      }
    },

    //左侧菜单接口
    getMenuInfo() {
      let url = this.$api02 + "/api/EbayCustomer/Menu/GetMenuEn";
      post(url).then((res) => {
        this.menuInfo = res.Results;
        this.isLight();
      });
    },
    //用户信息
    userTopInfo() {
      // this.api.url=this.$api02+'/api/CustomerInfo/GetCustomerInfoByToken';
      this.api.url =
        this.$api04 + "/Basics/api/CustomerInfo/GetCustomerInfoByToken";
      this.api.param = {};
      post(this.api.url, this.api.param).then((res) => {
        //用户信息对象
        sessionStorage.setItem("SalesInfos", JSON.stringify(res.Results));

        if (res.Results) {
          this.userName = res.Results.UserName;
          // 英文截取前两位，中文截取两个首字母
          if (this.userName) {
            let userNameList = this.userName.split("");
            if (this.userName.indexOf(' ') != -1) {
              userNameList = this.userName.split(" ");
              console.log(userNameList);
            }
            let userNameTwo = [];
            userNameList.forEach((item, index) => {
              if (index <= 1) {
                let userNameTwoItem = "";
                if (/[\u4e00-\u9fa5]/.test(item)) {
                  userNameTwoItem = pinyin(item, {
                    pattern: "initial",
                    type: "array",
                  })[0].toLocaleUpperCase();
                  if (userNameTwoItem.length > 1) {
                    userNameTwoItem = userNameTwoItem
                      .substring(0, 1);
                  }
                } else {
                  userNameTwoItem = item.toLocaleUpperCase();
                  if (item.length > 1) {
                    userNameTwoItem = item.slice(0, 1).toLocaleUpperCase();
                  }
                }
                userNameTwo.push(userNameTwoItem);
              }
            });
            this.userNameTwo = userNameTwo.join("");
          }

          this.userEmail = res.Results.Mail;
          this.loginName = res.Results.LoginName;
          setCustomer(res.Results); //将客户信息存到session里  如果没有就存
          bus.$emit("IsWCA", res.Results.IsWCA);
          bus.$emit("CusInfos", res.Results);
          if (res.Results.CompanyLogoImg) {
            this.companyLogo =
              this.$apiFileCloud + "/" + res.Results.CompanyLogoImg;
          } else {
            this.companyLogo = require("../../assets/img/logoWhite.png");
          }
          this.UnreadInformation(); //刚进来调用一次
        }
      });
    },
    //退出接口
    clkLogout() {
      delCookie("X-BY-EnTOKEN");
      window.location.href = "/reg/login";
    },

    //----未读消息-----
    //信息超出15个字后用省略号显示
    subsChannelText(val) {
      let newText = val;
      let bodymsg = newText.replace(/<\/?.+?>/g, ""); //查找<>或者 </>里面的内容替换成空
      let msg = bodymsg.replace(/ /g, ""); //得到后的内容  //空格替换成空
      if (msg.length > 33) {
        msg = msg.substring(0, 33) + "...";
      }
      return msg;
    },

    //货物未读消息有多少条
    UnreadInformation() {
      let that = this;
      let Name = that.loginName + "-CUS";
      that.api.param = {
        userNames: Name,
      };
      // that.api.url=that.$api03+'/api/TradeCustomer/OrderOnlineInfo/GetUnReadMsg';
      that.api.url = that.$api04 + "/Basics/api/IM/GetUnReadMsg";
      fetch(that.api.url, that.api.param).then(function (res) {
        if (res.Results) {
          that.InformationInfo = res.Results.msg_list;
          that.InformationSum = res.Results.Total;
        }
      });
    },
  },
};
</script>

<style >
.menuNva .el-menu--inline .el-menu-item {
  user-select: none;
  padding: 0 0 0 28px !important;
  height: 40px;
  line-height: 40px;
  background-color: #303745;
  color: #afb4b9;
  min-width: 160px;
}
.menuNva .is-active {
  background-color: #004fb1 !important;
  color: white !important;
}
.menuNva .el-menu-item {
  min-width: 160px;
  color: #afb4b9;
}
.menuNva .el-menu--inline {
  min-width: 160px;
  background: #303745 !important;
}
.menuNva .el-submenu__title,
.menuNva .topmenu {
  min-width: 160px;
  padding: 0 10px !important;
  background-color: #162434;
  color: #afb4b9;
}
.menuNva .el-menu-item,
.menuNva .el-submenu__title {
  height: 40px;
  font-size: 13px;
  line-height: 40px;
}
.menuNva .el-submenu__title:hover {
  background-color: #162434 !important;
}
.menuNva .el-menu-item:focus,
.menuNva .el-menu-item:hover {
  background-color: #004fb1 !important;
  color: white !important;
}
</style>
<style type="text/css" rel="stylesheet" scoped="scoped">
.userBg {
  background-color: #f2f2f2;
  height: 100%;
}
/*左侧导航 css*/
.menuNva {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  width: 160px;
  background-color: #162434;
  z-index: 10;
}
.menuNva .logo {
  margin: 30px 18px 27px 18px;
  height: 32px;
}

/*右侧内容 css*/
.menuRCon {
  min-width: 1100px;
  margin-left: 160px;
}
.menuTop {
  height: 48px;
  background-color: #fff;
  color: white;
  line-height: 48px;
  -moz-box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}
.menuTop .user {
  margin-right: 40px;
  padding: 0 20px;
  height: 48px;
  position: relative;
}
.menuTop .user .userImg img {
  margin-top: 10px;
  border-radius: 50%;
}

.menuTop .user .userImg i {
  transform: rotateZ(0deg);
  transition: all 0.3s;
}

.menuTop .user .user-img-new {
  position: relative;
  top: 0px;
  width: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 28px;
  border-radius: 50%;
  background: #3d74d5;
  border: 2px solid transparent;
  box-sizing: border-box;
}

.menuTop .user .user-img-new span {
  font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
  font-weight: bold;
  font-size: 14px;
  color: #ffffff;
  line-height: 20px;
  text-align: center;
  font-style: normal;
}

.menuTop .user:hover .user-img-new {
  border: 2px solid rgba(30, 81, 171, 0.24);
  box-sizing: border-box;
}

.menuTop .user:hover .userImg i {
  transform: rotateZ(180deg);
  transition: all 0.3s;
}

.menuTopImg {
  height: 36px;
  background-color: rgba(1, 79, 177, 0.08);
  border-radius: 19px;
  display: inline-block;
}
.w200 {
  width: 200px;
  margin: 7px 2px 7px 40px;
}
.w200 img {
  width: 169px;
  height: 32px;
}
.w157 {
  width: 157px;
  margin: 7px 5px;
}
.w157 img {
  width: 127px;
  height: 32px;
}
.w155 {
  width: 155px;
  margin: 7px 2px;
}
.w155 img {
  width: 125px;
  height: 32px;
}
.menuTopImg img {
  margin: 1px 0px 0px 15px;
}
/*未读消息 css*/
.location {
  position: relative;
}
.location:hover div {
  display: block;
}
.msgImg {
  position: relative;
  top: 10px;
}

.msgImg .msgNumber {
  position: absolute;
  top: 2px;
  right: 0;
  width: 8px;
  height: 8px;
  background: #d83f3f;
  border-radius: 4px;
}

.noticeBox {
  display: none;
  border-radius: 5px;
  position: absolute;
  right: -20px;
  top: 49px;
  background: #fff;
  z-index: 999;
  border: 1px solid #ddd;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.2);
}
.noticeBox i {
  background: url("../../assets/img/arrow-icon-s.png") no-repeat;
  width: 22px;
  height: 12px;
  display: block;
  position: absolute;
  top: -12px;
  left: 58%;
  z-index: 99;
}
.noticeBox ul {
  max-height: 550px;
  overflow-x: auto;
  padding: 0 10px;
}
.noticeBox ul li {
  color: #666;
  height: 100%;
  line-height: 30px;
  margin: 0 10px;
}
.specLi ul {
  margin: 5px;
}
.specLi ul li {
  line-height: 26px;
  margin: 0;
}
.noticeBox ul li.line {
  border-top: 1px solid #f0f0f0;
  margin: 0 -10px;
}
.noticeBox ul li .basInfo {
  display: block;
  padding: 0 20px;
  margin: 0 -20px;
}
.noticeBox ul li .basInfo:hover {
  background-color: #f0f0f0;
  color: #004fb1;
}
.lastLi {
  height: 25px;
  line-height: 25px;
  text-align: center;
  border-top: 1px solid #f0f0f0;
  margin: 0 -10px;
  font-weight: bold;
  color: #000;
}

.menuTop .msgIcons {
  padding: 0 20px;
  cursor: pointer;
  position: relative;
}
.menuTop .msgIcons:hover {
  background-color: #fff;
}
.menuTop .msgIcons .fa-iconMsg {
  font-size: 24px;
}
/* 设置消息样式，数字外边加个圆圈 */
.msgIcons .info {
  border-radius: 50%;
  line-height: 1px;
  background-color: red;
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  font-size: 12px !important;
  display: inline-block;
  position: absolute;
  z-index: 10;
  top: 7px;
  left: 32px;
}

.menuMain {
  margin: 10px 40px 25px 20px;
  min-width: 1150px;
}
.footerPosition {
  background: #f2f2f2;
}

/* .router-link-active{background:#004FB1;color:#fff !important;opacity:1;line-height:38px;display:block;} */
/* 由于expedit 是属于explist的导航条。所一给个css */
/* .other-router-link-active{background:#004FB1;color:#fff !important;opacity:1;line-height:38px;display:block;} */

.activeBlue {
  background: #004fb1;
  color: #fff !important;
  opacity: 1;
  line-height: 38px;
  display: block;
}
.mybyBgTitle {
  background: #004fb1;
  color: #fff !important;
}
.quotesBtn {
  width: 122px;
  height: 38px;
  line-height: 38px;
  margin: 0 auto 20px;
}
</style>






// WEBPACK FOOTER //
// src/components/userCenter/userCenterCom.vue